"use client";

import React from "react";
import { Minus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutSection() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255943" id="ontario-financial-toolkit" className="py-16 md:py-24 bg-background text-foreground overflow-hidden relative">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.02] flex items-center justify-center overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668301/img/ontario_trillium_watermark.png" alt="" className="w-[120%] h-auto max-w-none" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`relative h-[500px] lg:h-[700px] w-full rounded-md overflow-hidden shadow-xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668301/img/ontario_financial_abstract_3d.png" alt="3D abstract financial visualization" className="object-cover w-full h-full backdrop-blur-sm" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668301/img/ontario_financial_abstract_3d.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668301/img/ontario_financial_abstract_3d.png-wvc-sizes" loading="lazy" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-6 lg:gap-8 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-extrabold text-foreground leading-tight tracking-tighter">
              Navigate Ontario's Economy with Precision
            </h2>

          </div>

        </div>
      </div>
    </section>;
}